import { AuthConfig } from 'angular-oauth2-oidc';

export const authCodeFlowConfig: AuthConfig = {
  issuer: 'https://phiagroup.onelogin.com/oidc/2',
  redirectUri: window.location.origin + '/ignite/auth-callback',
  clientId: 'bf310bf0-656d-013c-b211-4ec0421f26c5177516',
  responseType: 'code',
  scope: 'openid profile email params',
  showDebugInformation: true,
  postLogoutRedirectUri: window.location.origin,
};

export const environment = {
  production: true,
  authCodeFlowConfig: authCodeFlowConfig,
  restHost: 'https://ignite-engine-rest-dev.azurewebsites.net/',
  pdsHost:'https://pds.mps.cms.gov/fiss/inpatient/providers/',
  //ippsHost:'https://webpricer.cms.gov/api/ipps-pricer/v2/price-claim',
  ippsHost: 'https://ippsapi.azurewebsites.net/v2/price-claim',
  supportUrl: 'https://thephiagroup.sysaidit.com/Login.jsp?manual=true'
};
